import type { FC } from "react";

import type { Variants } from "@/src/common/links/useSvgStyle";
import { useSvgVariant } from "@/src/common/links/useSvgStyle";
import * as stylex from "@stylexjs/stylex";

export const FacebookIcon: FC<{ style?: stylex.StyleXStyles; variant: Variants }> = ({ style, variant }) => {
    const { fill } = useSvgVariant(variant);

    return (
        <svg {...stylex.props(style)} viewBox="0 0 266.9 266.9">
            <path
                {...stylex.props(fill)}
                d="M248.1 4.6H18.8C11 4.6 4.6 11 4.6 18.8v229.3c0 7.9 6.4 14.2 14.2 14.2h123.4v-99.8h-33.6v-38.9h33.6V94.9c0-33.3 20.3-51.4 50-51.4 14.2 0 26.5 1.1 30 1.5v34.8h-20.6c-16.1 0-19.3 7.7-19.3 18.9v24.8h38.5l-5 38.9h-33.5v99.8H248c7.9 0 14.2-6.4 14.2-14.2V18.8c.1-7.8-6.3-14.2-14.1-14.2z"
            />
        </svg>
    );
};
